(() => {

    class HeroSlider {

        constructor(root) {

            this.root = root;

            this.slides = [...root.querySelectorAll('[data-slide]')];

            if (this.slides.length <= 1) return;

            this.prevButton = root.querySelector('[data-prev]');
            this.nextButton = root.querySelector('[data-next]');
            this.progress = root.querySelector('[data-progress]');

            this.index = 0;

            this.timer = null;

            this.dragging = false;

            this.startX = 0;
            this.currentX = 0;

            this.autoplay =
                root.dataset.autoplay === 'true';

            this.delay =
                Number(root.dataset.autoplaySpeed || 5) * 1000;

            this.bind();

            this.update();

            this.startAutoplay();

        }

        bind() {

            this.nextButton?.addEventListener('click', () => this.next());

            this.prevButton?.addEventListener('click', () => this.prev());

            this.root.tabIndex = 0;

            this.root.addEventListener('keydown', e => {

                if (e.key === 'ArrowRight')
                    this.next();

                if (e.key === 'ArrowLeft')
                    this.prev();

            });

            this.root.addEventListener('mouseenter', () => {

                this.stopAutoplay();

            });

            this.root.addEventListener('mouseleave', () => {

                this.startAutoplay();

            });

            document.addEventListener('visibilitychange', () => {

                if (document.hidden)
                    this.stopAutoplay();
                else
                    this.startAutoplay();

            });

            this.enableSwipe();

        }

        next() {

            this.index++;

            if (this.index >= this.slides.length)
                this.index = 0;

            this.update();

        }

        prev() {

            this.index--;

            if (this.index < 0)
                this.index = this.slides.length - 1;

            this.update();

        }

        update() {

            this.slides.forEach((slide, i) => {

                slide.classList.toggle(
                    'is-active',
                    i === this.index
                );

            });

            this.updateProgress();

        }

        updateProgress() {

            if (!this.progress) return;

            const width = 100 / this.slides.length;

            this.progress.style.width = `${width}%`;

            this.progress.style.left = `${this.index * width}%`;

            this.progress.style.transform = 'none';

        }

        startAutoplay() {

            if (!this.autoplay)
                return;

            this.stopAutoplay();

            this.timer = setInterval(() => {

                this.next();

            }, this.delay);

        }

        stopAutoplay() {

            clearInterval(this.timer);

        }

        enableSwipe() {

            const down = x => {

                this.dragging = true;

                this.startX = x;

                this.currentX = x;

                this.stopAutoplay();

            };

            const move = x => {

                if (!this.dragging)
                    return;

                this.currentX = x;

            };

            const up = () => {

                if (!this.dragging)
                    return;

                this.dragging = false;

                const delta =
                    this.currentX - this.startX;

                if (Math.abs(delta) > 60) {

                    if (delta < 0)
                        this.next();
                    else
                        this.prev();

                }

                this.startAutoplay();

            };

            this.root.addEventListener('mousedown', e => {

                down(e.clientX);

            });

            window.addEventListener('mousemove', e => {

                move(e.clientX);

            });

            window.addEventListener('mouseup', up);

            this.root.addEventListener('touchstart', e => {

                down(
                    e.touches[0].clientX
                );

            }, {
                passive: true
            });

            this.root.addEventListener('touchmove', e => {

                move(
                    e.touches[0].clientX
                );

            }, {
                passive: true
            });

            this.root.addEventListener(
                'touchend',
                up
            );

        }

    }

    document
        .querySelectorAll('[data-hero-slider]')
        .forEach(el => new HeroSlider(el));

})();